export default __webpack_public_path__ + "static/media/47.254ccc9d.jpg";